const CONFLICT_ERROR = 409;
export function hasGlobalError(result, error) {
  return Array.isArray(result.globalErrors) && result.globalErrors.some(e => e === error || e.includes(error));
}
export function isConflictStatusCode(fieldError) {
  return fieldError === CONFLICT_ERROR;
}